<template>
  <div class="contaier">
    <header-page></header-page>
    <div class="w-full h-[90%]">
      <!-- <div class="text-4xl font-bold text-center pt-[200px]">MOTORSHOW KAMLUNG</div> -->
      <div class="text-4xl font-bold text-center pt-[200px]">KAMLUNG</div>
      <div
        class="flex justify-evenly items-center flex-wrap md:flex-row flex-col md:pt-[80px] pt-[60px] md:pb-[200px] pb-[150px]"
      >
        <router-link :to="item.link" v-for="(item, index) in brandList" :key="index">
          <div
            class="w-[300px] h-[300px] flex justify-center items-center bg-[#f7f7f7] px-4 py-4 md:mt-0 mt-20 hover:bg-[#e7e7e7]"
          >
            <img class="w-[86%]" :src="item.img" alt="" />
          </div>
        </router-link>
      </div>
    </div>
    <!-- <div id="section1" class="w-full h-1"></div> -->
    <!-- <form-page ref="formPageRef"></form-page> -->
    <footer-page></footer-page>
  </div>
</template>

<script>
import HeaderPage from '@/components/HeaderPage.vue'
// import FormPage from '@/components/FormPage.vue'
import FooterPage from '@/components/FooterPage.vue'
export default {
  name: 'HomeView',
  components: {
    HeaderPage,
    // FormPage,
    FooterPage,
  },
  data() {
    return {
      // imageUrl: require("@/assets/img/list/7.jpg"),
      // imgsrc,
      // carouselList,
      // textList,
      speak: '中',
      brandList: [
        { name: 'ZEEKR', img: require('@/assets/img/ZEEKR_logo.svg'), link: '/zeekr' },
        { name: 'HONGQI', img: require('@/assets/img/logo_hongqi.png'), link: '/hongqi' },
        { name: 'iCAUR', img: require('@/assets/img/logo_icaur.png'), link: '/icaur' },
      ],
    }
  },
  computed: {},
  mounted() {
    //可能是router没准备好，用this.$router.onReady解决
    // this.$router.onReady(() => {
    //   let query = this.$route.query;
    //   console.log("onReady :>>query ", query);n
    // });
    // console.log("(this.$i18n.locale :>>11 ", this.$i18n.locale);
    // console.log("this.$route.query.lang :>> ", this.$route.query);
    // if (this.$route?.query?.lang) {
    //   console.log("存在 :>> ");
    //   if (this.$route.query.lang === "en") {
    //     this.$i18n.locale = "en";
    //     this.$refs.formPageRef.changeLanguage("zh");
    //     window.sessionStorage.setItem("sessionLang", "en");
    //   } else {
    //     this.$i18n.locale = "zh";
    //     this.$router.push({ path: "/survey", query: { lang: "zh" } }).catch((data) => {
    //       console.log("data :>>00 ", data);
    //     });
    //     window.sessionStorage.setItem("sessionLang", "zh");
    //   }
    // } else {
    //   let lang = window.sessionStorage.getItem("sessionLang") || "zh";
    //   console.log("不存在 :>> -sessionStorage", lang);
    //   if (lang === "zh") {
    //     console.log("进入11111", lang);
    //     this.$router.push({ path: "/survey", query: { lang: "zh" } }).catch((data) => {
    //       console.log("data :>> 1", data);
    //     });
    //     this.$i18n.locale = "zh";
    //   } else {
    //     console.log("进入22222", lang);
    //     this.$router.push({ path: "/survey", query: { lang: "en" } }).catch((data) => {
    //       console.log("data :>>2 ", data);
    //     });
    //     this.$i18n.locale = "en";
    //     this.$refs.formPageRef.changeLanguage("zh");
    //   }
    // }
  },
  methods: {
    // changeLanguage(lang) {
    //   console.log("changelang :>> ", lang);
    //   let lang_ = lang === "zh" ? "en" : "zh";
    //   this.$i18n.locale = lang_;
    //   window.sessionStorage.setItem("sessionLang", lang_);
    //   this.$refs.formPageRef.changeLanguage(lang);
    //   if (lang === "zh") {
    //     this.$router.push({ path: "/survey", query: { lang: "en" } }).catch((data) => {
    //       console.log("data :>> 3", data);
    //     });
    //     // this.$router.push(getLocalePath('/about', 'en'))
    //   } else {
    //     this.$router.push({ path: "/survey", query: { lang: "zh" } }).catch((data) => {
    //       console.log("data :>>4 ", data);
    //     });
    //   }
    // },
    // testFn() {
    //   console.log("this.$i18n.locale :>> ", this.$i18n.locale);
    // },
  },
}
</script>

<style lang="scss" scoped>
@import 'element-ui/lib/theme-chalk/display.css';
.contaier {
}
.top-banner {
  width: 100%;
  // height: 100vh;
  height: 86vh;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
